import { render, staticRenderFns } from "./VendorDefault.vue?vue&type=template&id=24364110&"
import script from "./VendorDefault.vue?vue&type=script&lang=js&"
export * from "./VendorDefault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports